// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QeBDcjU28BQ3y2c8{min-width:fit-content;background-color:var(--py-neutral-0)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"extendedPanel": `QeBDcjU28BQ3y2c8`
};
export default ___CSS_LOADER_EXPORT___;
